import { AuthManager } from "@bytescale/sdk"

const READY_POLL_INTERVAL_MS = 100
const READY_TIMEOUT_MS = 3000

/**
 * Resolve once the page's Bytescale auth session can authenticate CDN requests.
 *
 * On fresh page loads the session is established asynchronously, so a media player mounted
 * immediately could fire HLS requests before the service worker is authorized and burn its
 * retries on 401s. Resolves immediately when no session is being established (public pages),
 * and gives up after a short timeout so playback never hangs on auth trouble — the players'
 * direct-playback fallback covers that case.
 */
export default async function waitForBytescaleAuthSession(): Promise<void> {
    const deadline = Date.now() + READY_TIMEOUT_MS

    while (AuthManager.isAuthSessionActive() && !AuthManager.isAuthSessionReady() && Date.now() < deadline) {
        await new Promise((resolve) => setTimeout(resolve, READY_POLL_INTERVAL_MS))
    }
}
